"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ADD_ITEM_ERRORS = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _fireCustomEvent = _interopRequireDefault(require("@micado-digital/react-ui/utils/fireCustomEvent"));
var _parseObjectToFormData = _interopRequireDefault(require("../parseObjectToFormData"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const addItem = async _ref => {
  let {
    product,
    params,
    shop
  } = _ref;
  if ((0, _isEmpty.default)(params)) return;
  const {
    REACT_APP_PATH
  } = process.env;
  const FETCH_URL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/AddItem.api");
  const formData = (0, _parseObjectToFormData.default)(params);
  if (localStorage.getItem("mco-shop-cart-guid")) {
    formData.append("cartGUID", localStorage.getItem("mco-shop-cart-guid"));
  }
  const headers = {};
  if (localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }
  try {
    const response = await _axios.default.post(FETCH_URL, formData, {
      headers
    });
    const data = await response.data;
    const {
      guid,
      msg
    } = data;
    if (guid) {
      localStorage.setItem("mco-shop-cart-guid", guid);
    }
    if (!msg) {
      var _shop$currency, _product$price, _product$price2;
      (0, _fireCustomEvent.default)("add_to_cart", {
        ecommerce: {
          currency: shop === null || shop === void 0 || (_shop$currency = shop.currency) === null || _shop$currency === void 0 ? void 0 : _shop$currency.isoCode,
          value: product === null || product === void 0 || (_product$price = product.price) === null || _product$price === void 0 ? void 0 : _product$price.amount,
          items: [{
            item_name: product === null || product === void 0 ? void 0 : product.title,
            item_variant: product === null || product === void 0 ? void 0 : product.combinationID,
            price: product === null || product === void 0 || (_product$price2 = product.price) === null || _product$price2 === void 0 ? void 0 : _product$price2.amount
          }]
        }
      });
    }
    return data;
  } catch (error) {
    return error;
  }
};
const ADD_ITEM_ERRORS = exports.ADD_ITEM_ERRORS = {
  customprice_not_allowed: "CART_ITEM_NOT_ADDED",
  max_quantity_exceeded: "MAX_QUANTITY_EXCEEDED",
  not_available: "PRODUCT_NOT_AVAILABLE",
  parameter_missing: "CART_ITEM_NOT_ADDED",
  product_not_found: "CART_ITEM_NOT_ADDED",
  shop_not_found: "CART_ITEM_NOT_ADDED"
};
var _default = exports.default = addItem;